export default "__VITE_ASSET__BK66qTAk__"